module.exports = __webpack_public_path__ + "static/img/learning_guide.b3e85650.jpg";